import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../firmwareAssignmentState/firmwareAssignmentContext';
import { Pagination } from 'antd';
import style from './PaginationComponent.module.scss';

const PaginationComponent: React.FC = () => {
	const { changeCurrentPage, firmwareForAssign, currentPage, countOfItems } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const from = (currentPage - 1) * Number(countOfItems) + 1;
	const to = currentPage * Number(countOfItems);
	const total = firmwareForAssign.count;

	return (
		<div className={style.container} data-test="PaginationComponent">
			<Text
				className={style.counter}
				translationNameSpace="listing"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={currentPage}
				pageSize={Number(countOfItems)}
				total={firmwareForAssign.count}
				onChange={changeCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug} />
		</div>
	);
};

export default PaginationComponent;
